import { ABU, buildSubView, Em, FormWrapper, playContext, SaleResult, showMsg, TestPage } from "@client";
import { Style } from "@client/style";
import { NpcModel } from "@npc";
import { calcDepositP, calcScore, getXPercent, SaleX, SceneConst, SubNamespace, waitSeconds } from "@share";
import { Button, Form, Input, InputNumber, message, Radio } from "antd";
import React, { useContext, useState } from "react";

function Play({ playDone }: { playDone: () => void }) {
  const { saveResult } = useContext(playContext);
  const [p1, setP1] = useState(null as number),
    [p2, setP2] = useState(null as number),
    [saleXList, setSaleXList] = useState(null! as SaleX[]);
  if (saleXList) {
    return <SaleResult sale_X={saleXList} />;
  }
  return (
    <FormWrapper>
      <Form style={{ margin: "2rem" }}>
        <Form.Item label="产品成本">
          <span>{SceneConst.saleFurniture.cost}</span>
        </Form.Item>
        <Form.Item label="总价">
          <InputNumber
            min={SceneConst.saleFurniture.cost}
            max={1e4}
            value={p2}
            placeholder={(SceneConst.saleFurniture.cost * 2).toString()}
            onChange={(val: number) => setP2(val)}
          />
        </Form.Item>
        <Form.Item label="定金">
          <InputNumber min={1} max={p2 >> 1} value={p1} onChange={(val: number) => setP1(val)} />
        </Form.Item>
        <div style={{ textAlign: "center" }}>
          <Button
            className={Style.btnPrimarySm}
            onClick={async () => {
              if (!p2) {
                return message.warn("请检查你的总价");
              }
              if (!p1) {
                return message.warn("请检查你的定金");
              }
              const { pBuy, pDeposit } = calcDepositP(SceneConst.saleFurniture.cost, p1, p2);
              const saleXList = Array(SceneConst.saleFurniture.buyerAmount)
                .fill(null)
                .map(() =>
                  Math.random() < pBuy ? SaleX.DepositBuy : Math.random() < pDeposit ? SaleX.Deposit : SaleX.NoBuy
                );
              setSaleXList(saleXList);
              await waitSeconds(3);
              const X_noBuy = getXPercent(saleXList, SaleX.NoBuy),
                X_deposit = getXPercent(saleXList, SaleX.Deposit),
                X_depositBuy = getXPercent(saleXList, SaleX.DepositBuy),
                profit =
                  SceneConst.saleFurniture.buyerAmount *
                  (p1 * X_deposit + X_depositBuy * (p2 - SceneConst.saleFurniture.cost));
              await showMsg(
                <p>
                  你设置了定金<Em>{p1}</Em>
                  ，和总价<Em>{p2}</Em>。有
                  <Em>{(X_depositBuy * 100).toFixed(2)}%</Em>
                  %的买家选择了支付定金并且返回购买；有
                  <Em>{(X_deposit * 100).toFixed(2)}</Em>
                  %的买家选择了支付定金，但没有选择购买；有
                  <Em>{(X_noBuy * 100).toFixed(2)}</Em>
                  %的买家选择了不购买。因此你的利润为
                  <Em>{profit.toFixed(2)}</Em>
                </p>,
                {
                  okText: "知道了",
                }
              );
              saveResult({
                score: calcScore(
                  0,
                  saleXList.filter((s) => s === SaleX.DepositBuy).length,
                  SceneConst.saleFurniture.buyerAmount
                ),
                p1,
                p2,
                saleXList,
              });
              playDone();
            }}
          >
            确定
          </Button>
        </div>
      </Form>
    </FormWrapper>
  );
}

function Test({ done }: { done: (answers, answerScores) => void }) {
  return (
    <TestPage
      questions={[
        {
          Content: ({ inputProps }) => (
            <div>
              <p>
                假设某一产品在市场中的现有价格均为1000，预付定金200。如果一位买家认为其货币效用为1200，如果搜寻可能有50%的概率发现效用=1500的产品，有50%的概率发现效用=1200的产品。买家的搜寻成本为80。在这样的情形下，买家应如何决策？
              </p>
              <Radio.Group {...inputProps({ margin: ".5rem" })}>
                <Radio value={1}>A. 支付定金并搜寻</Radio>
                <Radio value={2}>B. 不支付定金并搜寻</Radio>
                <Radio value={3}>C. 购买</Radio>
                <Radio value={4}>D. 随机选择</Radio>
              </Radio.Group>
            </div>
          ),
          Answer: () => (
            <p>
              买家的现有净收益为1200-1000=200
              <br />
              买家的预期净收益为(1500+1200)/2-1000 = 350
              <br />
              搜寻产生的净剩余为350-200-80&gt;0 应该搜寻
              <br />
              因为搜寻不会带来更差的结果 不需要支付定金
            </p>
          ),
          answer: [2],
        },
        {
          Content: ({ inputProps }) => (
            <div>
              <p>
                假设某一产品现有价格为1000，预付定金200。如果一位买家认为其货币效用为1200，如果搜寻可能有50%的概率发现效用=1500的产品，有50%的概率发现效用=800的产品。买家的搜寻成本为80。在这样的情形下，买家是否选择搜寻？
              </p>
              <Radio.Group {...inputProps({ margin: ".5rem" })}>
                <Radio value={1}>A. 支付定金并搜寻</Radio>
                <Radio value={2}>B. 不支付定金并搜寻</Radio>
                <Radio value={3}>C. 购买</Radio>
                <Radio value={4}>D. 随机选择</Radio>
              </Radio.Group>
            </div>
          ),
          Answer: () => (
            <p>
              买家的现有净收益为1200-1000=200
              <br />
              -如果支付定金：
              <br />
              买家的预期净收益为(（1500-200）+（1200）)/2-1000 =250
              <br />
              搜寻产生的净剩余为250-200-80&lt;0
              <br />
              -如果不支付定金（从而无法再次购买该产品）：
              <br />
              买家的预期净收益为(1500+800)/2-1000 = 115
              <br />
              不应该搜寻
              <br />
            </p>
          ),
          answer: [3],
        },
        {
          Content: ({ inputProps }) => (
            <div>
              <p>
                一位买家访问一位卖家，并且检视某一产品/服务，该产品/服务的价值服从某一分布。比如u服从0-1均匀分布。买家知道他有一个【外部选项】，该外部选项也服从某一分布，比如外部选项v也服从0-1均匀分布。买家在选择搜寻外部选项是，会有潜在的搜寻成本，比如s=1/18。如果卖家不使用任何销售策略，并允许买方返回购买，则买方的保留价格为：
              </p>
              <Radio.Group {...inputProps({ margin: ".5rem" })}>
                <Radio value={1}>A.1/3</Radio>
                <Radio value={2}>B.2/3</Radio>
                <Radio value={3}>C.1/6</Radio>
                <Radio value={4}>D.1/18</Radio>
              </Radio.Group>
            </div>
          ),
          Answer: () => <img src={`${ABU}answer/7.3.png`} />,
          answer: [2],
        },
        {
          Content: ({ inputProps }) => (
            <div>
              <p>上题中，卖方的最优定价为：</p>
              <Radio.Group {...inputProps({ margin: ".5rem" })}>
                <Radio value={1}>A.1/18</Radio>
                <Radio value={2}>B.5/18</Radio>
                <Radio value={3}>C.1/2</Radio>
                <Radio value={4}>D.1/3</Radio>
              </Radio.Group>
            </div>
          ),
          Answer: () => <img src={`${ABU}answer/7.4.png`} />,
          answer: [2],
        },
        {
          isAnalysis: true,
          Content: ({ inputProps }) => (
            <div>
              <p>请结合本次任务数据， 谈谈风险偏好、态度、心理因素是如何影响搜寻决策的？无正确的答案，只需说明理由。</p>
              <br />
              <Input.TextArea maxLength={2e3} rows={4} {...inputProps({ width: "100%" })} />
            </div>
          ),
        },
      ]}
    />
  );
}

export const SaleFurnitureView = buildSubView({
  namespace: SubNamespace.SaleFurniture,
  bg: `${ABU}scene/bg/SaleFurniture.jpg`,
  label: "卖家具",
  npcModel: NpcModel.BuyCar,
  introMsg: () => [
    ...`1.\t假设买家有一个单位的购买需求。买家总会先访问你。
2.\t买家访问你时将了解到你的产品对于他的“货币效用”和需要购买产品所支付的价格。
3.\t买家有以下几种选择：（1）购买你的产品，获得产品的净收益（2）放弃购买，选择搜寻，并以一定的概率获得一个“外部收益”。
`
      .trim()
      .split("\n"),
    <p>
      4.买家的“货币效用”和“外部收益”均服从
      <Em>
        {SceneConst.saleFurniture.utility.MIN}，{SceneConst.saleFurniture.utility.MAX}
      </Em>
      之间的均匀分布。
    </p>,
    ...`
5.\t你可以选择两种销售模式。在常规销售模式下，你选择一个单一的出售价格，买家可以选择搜寻以后返回购买；在预付定金模式下，你需要选择预付定金的价格和商品的总价。买家必须预付定金才能选择返回购买。
6.\t买家的搜寻成本为【${(SceneConst.saleFurniture.cost / 10).toFixed(1)}】。`
      .trim()
      .split("\n"),
  ],
  npcWelcome: async () => {
    await showMsg("现在你作为销售人员，需要对公司的销售策略做出建议。你所负责的业务板块是家具销售。");
    await showMsg(
      "本市的家具市场中有大量的“理性”买家，假设这些买家将完全基于最大化个人期望收益来选择行动。你需要帮助公司决定最优销售策略。",
      {
        okText: "下一步",
      }
    );
  },
  Play,
  Test,
  initState: (s) => s,
});
